// @flow
import React from 'react';
import AuthFormContainer from 'containers/auth/AuthFormContainer';
import AuthTemplate from 'components/auth/AuthTemplate';
import PageTemplate from 'components/base/PageTemplate';

const Login = () => {
  return <AuthTemplate type={'로그인'} form={<AuthFormContainer typeName={'로그인'} />} />;
};

export default Login;



// WEBPACK FOOTER //
// ./src/pages/Login.js